export default {"src":"/_next/static/media/toothMagnifying_40.68bd5e63.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};